const KEY = "wembii-pending-canva-design-picker";

export function storePendingCanvaDesignPicker(): void {
  sessionStorage.setItem(KEY, "1");
}

/** Lee y elimina la marca para abrir el selector tras volver de OAuth Canva. */
export function takePendingCanvaDesignPicker(): boolean {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return false;
    sessionStorage.removeItem(KEY);
    return true;
  } catch {
    return false;
  }
}
